<template>
    <button
        class="relative inline-flex flex-col items-center hover:cursor-pointer py-1 px-2 lg:px-3 rounded-lg text-link hover:bg-base-200 md:hidden"
        :class="flyoutContext === 'search' ? 'bg-secondary hover:bg-secondary text-secondary-content' : false"
        @click="toggleFlyout('search')"
    >
        <div class="w-6 h-6 lg:w-8 lg:h-8">
            <MiscIcon
                v-if="flyoutContext === 'search'"
                name="x"
                class="w-6 h-6 lg:w-8 lg:h-8"
                size="none"
            />
            <MiscIcon
                v-else
                name="search"
                class="w-6 h-6 lg:w-8 lg:h-8"
                size="none"
            />
        </div>

        <span class="text-base lg:text-lg inline-block leading-6">
            {{ t('layout.header.actions.search.label') }}
        </span>
    </button>

    <MiscLink
        class="relative flex-col items-center hover:cursor-pointer py-1 px-2 lg:px-3 rounded-lg text-link hover:bg-base-200 hidden lg:inline-flex"
        to="/customer/wishlist"
    >
        <div class="indicator inline-flex flex-col items-center">
            <MiscIcon name="wishlist" class="w-6 h-6 lg:w-8 lg:h-8" size="none" />

            <span class="text-base lg:text-lg inline-block leading-6">
                {{ t('layout.header.actions.wishlist.label') }}
            </span>

            <client-only>
                <span v-if="miniWishlist?.length > 0" class="badge badge-new badge-sm [--size:1.125rem] indicator-item top-3 right-8 text-base" v-text="miniWishlist?.length" />
            </client-only>
        </div>

    </MiscLink>

    <div ref="dropdown" class="dropdown dropdown-start hidden lg:block">
        <client-only>
            <CustomerState :label="t('layout.header.actions.account.label')" />

            <template #fallback>
                <div class="relative inline-flex flex-col items-center hover:cursor-pointer py-1 px-2 lg:px-3 rounded-lg text-link hover:bg-base-200">
                    <MiscIcon name="user" size="xl" />

                    <span class="text-base lg:text-lg inline-block leading-6">
                        {{ t('layout.header.actions.account.label') }}
                    </span>
                </div>
            </template>
        </client-only>
    </div>

    <button
        class="relative flex-col items-center hover:cursor-pointer py-1 px-2 lg:px-3 rounded-lg text-link hover:bg-base-200 inline-flex lg:hidden"
        :class="flyoutContext === 'menu' ? 'bg-secondary hover:bg-secondary text-secondary-content' : false"
        @click="toggleFlyout('menu')"
    >
        <div class="w-6 h-6 lg:w-8 lg:h-8">
            <MiscIcon
                v-if="flyoutContext === 'menu'"
                name="x"
                class="w-6 h-6 lg:w-8 lg:h-8"
                size="none"
            />
            <MiscIcon
                v-else
                name="bars"
                class="w-6 h-6 lg:w-8 lg:h-8"
                size="none"
            />
        </div>

        <span class="text-base lg:text-lg inline-block leading-6">
            {{ t('layout.header.actions.menu.label') }}
        </span>
    </button>

    <button
        class="relative py-1 px-2 lg:px-3 rounded-lg text-buy-content bg-buy hover:bg-buy-focus hover:cursor-pointer"
        @click="toggleDrawer('cart', 'right')"
    >
        <div class="indicator inline-flex flex-col items-center">
            <client-only>
                <MiscIcon
                    v-if="miniCart?.qty > 0"
                    name="shopping-cart-full"
                    class="w-6 h-6 lg:w-8 lg:h-8"
                    size="none"
                />
                <MiscIcon
                    v-else
                    name="shopping-cart-empty"
                    class="w-6 h-6 lg:w-8 lg:h-8"
                    size="none"
                />

                <template #fallback>
                    <MiscIcon name="shopping-cart-empty" class="w-6 h-6 lg:w-8 lg:h-8" size="none" />
                </template>
            </client-only>
            <span class="text-base lg:text-lg hidden md:inline-block leading-6">
                {{ t('layout.header.actions.cart.label') }}
            </span>

            <span class="text-base lg:text-lg inline-block md:hidden leading-6">
                {{ t('layout.header.actions.cart.labelMobile') }}
            </span>

            <client-only>
                <span v-if="filteredLineItems(miniCart?.items).length > 0" class="badge badge-new badge-sm [--size:1.125rem] indicator-item top-3 -right-2 text-base">
                    {{ filteredLineItems(miniCart?.items).length }}
                </span>
            </client-only>
        </div>
    </button>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCart, useDrawer, useWishlist, useFlyout } from '#imports'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const { toggleDrawer } = useDrawer()
const { toggleFlyout, flyoutContext } = useFlyout()

const cartStore = useCart()
const { miniCart } = storeToRefs(cartStore)

const wishlistStore = useWishlist()
const { miniWishlist } = storeToRefs(wishlistStore)

function filteredLineItems(items: any) {
    return items?.filter(item => item?.price >= 1) || [];
}

const dropdown = ref(null)
const { currentRoute } = useRouter()

watch(currentRoute, async (value) => {
    if(dropdown?.value?.contains(document?.activeElement)) {
        document?.activeElement?.blur()
    }
})
</script>
